
<div class=" w-full h-5 font-extrabold relative flex justify-center align-top ">
</div>

<!-- this element has to be half of the above for :after to work -->
<div class="bg-gray-600 h-1.5"></div>


<div class="bg-gray-400 w-full h-4 flex justify-center p-1">
</div>

@if (hasFrame()){

    <div class="w-full bg-gray-300 border-2 border-gray-600 h-4 flex justify-center pb-0 content-end relative"  >

        @if(assemblyFrameValues().hasReinforcement){
            <img src="assets/images/icons/reinforcement.svg" class="w-3 h-3">
        }

        @if(showReinforcementAddedMessage()){
            <div class="absolute bottom-0 translate-y-11 border-gray-600 border-2 p-1 bg-gray-50 text-s animate-appear">
                {{ 'reinforcement.added' }}
            </div>
        }

    </div>

}
